export default "__VITE_ASSET__B$fSWc6Q__"